import { render, staticRenderFns } from "./areaNewsList.vue?vue&type=template&id=27eb9f30&scoped=true"
import script from "./areaNewsList.vue?vue&type=script&lang=js"
export * from "./areaNewsList.vue?vue&type=script&lang=js"
import style0 from "./areaNewsList.vue?vue&type=style&index=0&id=27eb9f30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27eb9f30",
  null
  
)

export default component.exports